export default "/fonts/vendor/katex/dist/KaTeX_Fraktur-Regular.ttf?ed305b5434865e06ffde7da0d28101af";